import React from "react";

interface InfoIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function InfoIcon(props: InfoIconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="7" cy="4.5" r="0.5" fill="currentColor" />
      <path d="M7 6.5V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
